import {MatDialogRef} from "@angular/material/dialog";
import {firstValueFrom} from "rxjs";

/** Returnerer verdien angitt dialog returnerte med når den ble lukket. */
export function dialogRespons<T>(dialog: MatDialogRef<any, T>): Promise<T|undefined>;
export function dialogRespons<T>(dialog: MatDialogRef<any, T>, standardVedLukketVerdi: T): Promise<T>;
export function dialogRespons<T>(dialog: MatDialogRef<any, T>, standardVedLukketVerdi?: T): Promise<T|undefined> {
    return firstValueFrom(dialog.beforeClosed(), {defaultValue: standardVedLukketVerdi});
}
